import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useStyles } from './TransfersIndexPage.style'
import {
  Button,
  TextField,
  CircularProgress,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  Tooltip
} from '@material-ui/core'
import {
  Check,
  HighlightOff,
  PictureAsPdf,
  Info,
  FileCopyOutlined,
  Visibility,
  CheckBoxOutlineBlank,
  Search
} from '@material-ui/icons'
import {
  loadTransfersPaged,
  updatePaymentStatusOrder
} from '~/state/modules/orders'
import clsx from 'clsx'
import * as moment from 'moment'
import { ConfirmationDialog } from '~/views/shared'
import { setPreviousRoute } from 'state/modules/users'
import { TableGrid, createColumn, createCustomColumn } from '~/views/shared'
import { currencyIntegerFormat } from 'views/utils/functions'
import { ROUTES } from '~/views/routes'
import copy from 'copy-to-clipboard'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'
import { ROLES } from 'config/constants'
import { useTheme, useMediaQuery } from '@material-ui/core'
import { PAYMENTS_STATUS, PAYMENT_STATUS_LABELS } from 'config/constants'

export const TransfersIndexPage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const roleId = '6687d11a-81b1-42f7-bc24-1c2ffb081111'
  const [prevRoleId, setPrevRoleId] = useState(roleId)
  const {
    transfersPaged,
    pendingTransfersPaged,
    transferParams,
    pendingUpdateStatus
  } = useSelector((state) => state.orders)
  const { user: userLogin } = useSelector((state) => state.login)
  const [search, setSearch] = useState(transferParams?.searchParams || '')
  const history = useHistory()
  const theme = useTheme()
  const isUpMedium = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true })
  const rolesArray = userLogin?.roles?.split(',') || []
  const [open, setOpen] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [orderId, setOrderId] = useState('')
  const [openReject, setOpenReject] = useState(false)
  const [openConfirmApprove, setOpenConfirmApprove] = useState(false)
  const [statusFilter, setStatusFilter] = useState(PAYMENTS_STATUS.IN_PROGRESS)

  const handleOpenReject = (order) => {
    setSelectedOrder(order)
    setOpenReject(true)
  }

  const handleOpenApprove = (order) => {
    setSelectedOrder(order)
    setOpenConfirmApprove(true)
  }

  const handleCloseReject = () => {
    setOpenReject(false)
    setSelectedOrder(null)
  }

  const handleCloseApprove = () => {
    setOpenConfirmApprove(false)
    setSelectedOrder(null)
  }

  const handleConfirmReject = async () => {
    if (selectedOrder) {
      await dispatch(
        updatePaymentStatusOrder(selectedOrder.Id, PAYMENTS_STATUS.REJACTED)
      )
      handleCloseReject()
      showSnackbarSuccess('Compra rechazada correctamente')
      performSearch()
    }
  }

  const handleConfirmApprove = async () => {
    if (selectedOrder) {
      await dispatch(
        updatePaymentStatusOrder(selectedOrder.Id, PAYMENTS_STATUS.APPROVED)
      )
      handleCloseApprove()
      showSnackbarSuccess('Compra aprobada correctamente')
      performSearch()
    }
  }

  const handleClose = () => {
    setOpen(false)
    setOrderId('')
  }

  const copyToClipBoard = () => {
    try {
      copy(orderId)
      showSnackbarSuccess('¡Id copiado al Portapapeles!', '')
      setOpen(false)
      setOrderId('')
    } catch (error) {
      showSnackbarError(error)
    }
  }

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      performSearch()
    }
  }

  const performSearch = () => {
    const trimmed = (search || '').trim()
    const searchParam = trimmed === '' ? null : trimmed
    dispatch(
      loadTransfersPaged(statusFilter, {
        searchParams: searchParam,
        pageSize: 5,
        page: 0,
        sortBy: transferParams?.sortBy || 'CreatedDate',
        sortAscending: transferParams?.sortAscending ?? true
      })
    )
  }

  const handleOpen = (id) => {
    setOrderId(id)
    setOpen(true)
  }

  const handleOpenReceiptModal = (fileUrl) => {
    if (fileUrl) {
      const width = 800
      const height = 600
      const left = (window.screen.width - width) / 2
      const top = (window.screen.height - height) / 2

      window.open(
        fileUrl,
        'Comprobante',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,toolbar=no,location=no,menubar=no,status=no`
      )
    }
  }

  useEffect(() => {
    dispatch(
      setPreviousRoute(ROUTES.ADMIN.ROLES.INDEX.replace(':roleId', roleId))
    )
  }, [dispatch])

  useEffect(() => {
    if (roleId !== prevRoleId) {
      setSearch('')
      setPrevRoleId(roleId)
    }
  }, [roleId, prevRoleId])

  const handleStatusChange = async (event) => {
    const status = parseInt(event.target.value, 10)
    const newStatus = status
    setStatusFilter(newStatus)
    setSearch('')
    await dispatch(
      loadTransfersPaged(newStatus, {
        searchParams: null,
        pageSize: 5,
        page: 0,
        sortBy: 'CreatedDate',
        sortAscending: true
      })
    )
  }

  const makeSearchForm = () => {
    return (
      <div className={classes.form}>
        <TextField
          fullWidth
          className={classes.input}
          placeholder='Filtrar por Evento, DNI, Apellido o Nombres'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyPress={handleSearchKeyPress}
        />
        <Button
          disabled={pendingTransfersPaged}
          variant='contained'
          color='primary'
          size={isUpMedium ? 'medium' : 'small'}
          onClick={performSearch}
          style={{
            minWidth: isUpMedium ? 96 : 40,
            padding: isUpMedium ? '6px 16px' : '6px 8px'
          }}>
          {pendingTransfersPaged ? (
            <CircularProgress size={24} color='inherit' />
          ) : isUpMedium ? (
            'Buscar'
          ) : (
            <Search />
          )}
        </Button>
      </div>
    )
  }

  const makeColumns = (isAdmin, history, handleOpen, classes) => {
    return [
      ...(isAdmin
        ? [
            createCustomColumn(
              (c) => (
                <IconButton
                  onClick={() => {
                    handleOpen(c.Id)
                  }}>
                  <Visibility />
                </IconButton>
              ),
              'ID'
            )
          ]
        : []),
      createColumn('CreatedDate', 'Fecha de Operación', 'left', (x) =>
        moment(x).format('DD/MM/YYYY HH:mm')
      ),
      createCustomColumn(
        (c) => (
          <Typography className={classes.tableCell}>
            {`${isAdmin ? `(${c.EventId}) ` : ''}${c.EventName}`}
          </Typography>
        ),
        'Nombre del Evento'
      ),
      createCustomColumn((c) => {
        const tickets = c.Tickets || []
        return tickets.map((t) => (
          <Typography
            key={t.TicketId}
            className={
              classes.tableCell
            }>{`${t.TicketName}: ${t.Quantity}`}</Typography>
        ))
      }, 'Tickets'),
      createCustomColumn(
        (c) => (
          <Typography className={classes.tableCell}>
            {c.IdentificationNumber}
          </Typography>
        ),
        'DNI'
      ),
      createCustomColumn(
        (c) => (
          <Typography className={classes.tableCell}>{c.FullName}</Typography>
        ),
        'Nombre y Apellido'
      ),
      createCustomColumn(
        (c) => (
          <Typography
            className={clsx({
              [classes.status]: true,
              [classes.statusApproved]:
                c.PaymentStatus === PAYMENTS_STATUS.APPROVED,
              [classes.statusRejected]:
                c.PaymentStatus === PAYMENTS_STATUS.REJACTED,
              [classes.statusInProgress]:
                c.PaymentStatus === PAYMENTS_STATUS.IN_PROGRESS,
              [classes.statusPending]:
                c.PaymentStatus === PAYMENTS_STATUS.PENDING,
              [classes.statusNotSet]:
                c.PaymentStatus === PAYMENTS_STATUS.NOT_SET,
              [classes.statusChargedBack]:
                c.PaymentStatus === PAYMENTS_STATUS.CHARGED_BACK,
              [classes.statusRefunded]:
                c.PaymentStatus === PAYMENTS_STATUS.REFUNDED,
              [classes.statusCancelled]:
                c.PaymentStatus === PAYMENTS_STATUS.CANCELLED,
              [classes.statusInMediation]:
                c.PaymentStatus === PAYMENTS_STATUS.IN_MEDIATION
            })}>
            {PAYMENT_STATUS_LABELS[c.PaymentStatus]}
          </Typography>
        ),
        'Estado de la Orden'
      ),
      createCustomColumn(
        (c) => (
          <Typography className={classes.tableCell}>
            {currencyIntegerFormat(c?.Amount)}
          </Typography>
        ),
        'Monto'
      ),
      createCustomColumn(
        (c) => (
          <IconButton
            onClick={() => handleOpenReject(c)}
            disabled={c.PaymentStatus !== PAYMENTS_STATUS.IN_PROGRESS}
            style={{
              color:
                c.PaymentStatus === PAYMENTS_STATUS.REJACTED ? 'red' : undefined
            }}>
            <HighlightOff />
          </IconButton>
        ),
        'Rechazar'
      ),
      createCustomColumn(
        (c) => (
          <IconButton
            onClick={() => handleOpenApprove(c)}
            disabled={c.PaymentStatus !== PAYMENTS_STATUS.IN_PROGRESS}
            style={{
              color:
                c.PaymentStatus === PAYMENTS_STATUS.APPROVED
                  ? 'green'
                  : undefined
            }}>
            {c.PaymentStatus === PAYMENTS_STATUS.APPROVED ? (
              <Check />
            ) : (
              <CheckBoxOutlineBlank />
            )}
          </IconButton>
        ),
        'Aprobar'
      ),
      createCustomColumn((c) => {
        const hasFileUrl = c.BankTransferDetails?.FileUrl
        return (
          <Tooltip title={!hasFileUrl ? 'No hay comprobante disponible' : ''}>
            <span>
              <IconButton
                onClick={() => {
                  if (hasFileUrl) {
                    handleOpenReceiptModal(c.BankTransferDetails.FileUrl)
                  }
                }}
                disabled={!hasFileUrl}>
                <PictureAsPdf />
              </IconButton>
            </span>
          </Tooltip>
        )
      }, 'Ver Comprobante'),
      ...(isAdmin
        ? [
            createCustomColumn(
              (c) => (
                <IconButton
                  onClick={() => {
                    history.push(
                      `${ROUTES.ADMIN.SUPPORT.ORDERS.DETAILS.replace(':orderId', c.Id)}?from=transfers`
                    )
                  }}>
                  <Info />
                </IconButton>
              ),
              'Ver Detalle'
            )
          ]
        : [])
    ]
  }

  const makeFooterActions = () => []

  return (
    <>
      <TableGrid
        title={
          <div className={classes.titleContainer}>
            <Typography className={classes.title}>Transferencias</Typography>
            <FormControl component='fieldset'>
              <RadioGroup
                row
                value={statusFilter}
                onChange={handleStatusChange}
                style={{ alignItems: 'center', justifyContent: 'end' }}>
                <FormControlLabel
                  value={PAYMENTS_STATUS.IN_PROGRESS}
                  control={<Radio color='primary' />}
                  label='En progreso'
                />
                <FormControlLabel
                  value={PAYMENTS_STATUS.APPROVED}
                  control={<Radio color='primary' />}
                  label='Aprobadas'
                />
                <FormControlLabel
                  value={PAYMENTS_STATUS.REJACTED}
                  control={<Radio color='primary' />}
                  label='Rechazadas'
                />
              </RadioGroup>
            </FormControl>
          </div>
        }
        columns={makeColumns(
          rolesArray?.includes(ROLES.ADMIN),
          history,
          handleOpen,
          classes
        )}
        footerActions={makeFooterActions()}
        searchForm={makeSearchForm}
        searchParams={search}
        loadItemsPage={(x) => {
          const trimmed = (search || '').trim()
          const searchParam = trimmed === '' ? null : trimmed
          dispatch(
            loadTransfersPaged(statusFilter, {
              searchParams: searchParam,
              page: x.pageNumber || transferParams?.page,
              pageSize: x.pageSize,
              sortBy: x.orderBy || 'CreatedDate',
              sortAscending: x.order
                ? x.order === 'asc'
                : (transferParams?.sortAscending ?? true)
            })
          )
        }}
        isLoading={pendingTransfersPaged}
        pagedList={transfersPaged}
        keyName='Id'
        pageSize={transferParams?.pageSize || 5}
        order={(transferParams?.sortAscending ?? true) ? 'asc' : 'desc'}
        orderBy={transferParams?.sortBy || 'CreatedDate'}
        useNewFormat
      />
      <ConfirmationDialog
        open={openConfirmApprove}
        loading={pendingUpdateStatus}
        handleConfirmation={handleConfirmApprove}
        onCancel={handleCloseApprove}
        title={'APROBAR COMPRA'}
        message={'Está por Aprobar la compra para el evento'}
        entityIdentifier={
          selectedOrder?.EventName ? `${selectedOrder.EventName}` : '-'
        }
        optionalMessage={'del usuario'}
        secondEntity={
          selectedOrder?.IdentificationNumber
            ? `(${selectedOrder.IdentificationNumber}) ${selectedOrder?.FullName}`
            : '-'
        }
      />
      <ConfirmationDialog
        open={openReject}
        loading={pendingUpdateStatus}
        handleConfirmation={handleConfirmReject}
        onCancel={handleCloseReject}
        title={'RECHAZAR COMPRA'}
        message={'Está por Rechazar la compra para el evento'}
        entityIdentifier={
          selectedOrder?.EventName ? `${selectedOrder.EventName}` : '-'
        }
        optionalMessage={'del usuario'}
        secondEntity={
          selectedOrder?.IdentificationNumber
            ? `(${selectedOrder.IdentificationNumber}) ${selectedOrder?.FullName}`
            : '-'
        }
      />
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          <Button
            onClick={copyToClipBoard}
            endIcon={<FileCopyOutlined />}
            className={classes.button}>
            {orderId}
          </Button>
        </DialogTitle>
      </Dialog>
    </>
  )
}

export default TransfersIndexPage
